module.exports = __webpack_public_path__ + "static/icons/icon-river--red-3f3f7e64a635526af848954a18a9d8ee.svg";